<h1 mat-dialog-title>Select {{feature}}</h1>
<div mat-dialog-content class="normal-dialog-content">
    <div class="custom">
        <mat-form-field appearance="outline" class="remove-padding">
            <mat-label>Custom Text</mat-label>
            <input matInput placeholder="" [(ngModel)]="custom">
        </mat-form-field>
    </div>
    
    <div class="option" (click)="selected(custom)">
        {{custom}}
    </div>

    <div class="option" (click)="selected(option)" *ngFor="let option of options">
        {{option}}
    </div>
</div>
<div mat-dialog-actions>
    <button  (click)="selected(current)" mat-button>Close</button>
</div>